import { FC } from 'react';

import CorporateScreenshot from '../assets/corporate-application-image.png';
import { useTranslations } from '../hooks/useTranslations.ts';
import { translationKeys } from '../translations/translationKeys.ts';
import ThankYouScreenWrapper, { ThankYouScreenProps } from './ThankYouScreenWrapper.tsx';

const ThankYouScreenCorporate: FC<ThankYouScreenProps> = (props) => {
  const { translate } = useTranslations();
  return (
    <ThankYouScreenWrapper {...props} title={translate(translationKeys.THANK_YOU_CORPORATE_TITLE)} disableOnMobile>
      <div>
        <ol className="list-decimal list-inside space-y-4 mb-6">
          <li className="text-base leading-6 text-content-secondary">
            {translate(translationKeys.THANK_YOU_CORPORATE_DESKTOP_LINK)}
          </li>
          <li className="text-base leading-6 text-content-secondary">
            {translate(translationKeys.THANK_YOU_CORPORATE_STEP)}
          </li>
          <li className="text-base leading-6 text-content-secondary">
            {translate(translationKeys.THANK_YOU_CORPORATE_COMPLETE)}
          </li>
        </ol>

        <div className="w-full rounded-lg overflow-hidden border border-surface-separator">
          <img
            src={CorporateScreenshot}
            alt="Platform screenshot showing Apply for a corporate account link"
            className="w-full h-auto"
          />
        </div>
      </div>
    </ThankYouScreenWrapper>
  );
};

export default ThankYouScreenCorporate;
